//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import commentService from "./commentService.js";
import Vue from "vue";
import ReplyForm from "./ReplyForm.vue";

export default {
  name: "CommentItem",
  componentName: "CommentItem",
  components: {},
  props: {
    item: {
      type: Object,
      default: null,
    },
    postid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cItem: this.item,
      cPostId: this.postid,
    };
  },
  methods: {
    like(e) {
      const div = e.target.parentElement.parentElement;
      const id = this.item.comment_ID;
      const post = commentService.like(id, 1);
      const rect = div.getBoundingClientRect() || {};
      const offset = rect.top || 100;
      if (!post) {
        return;
      }
      post
        .then((res) => {
          const data = res.data;
          if (data.code == -1) {
            this.alert(data.message, offset);
          } else if (data.code == 1) {
            // 成功 num +1
            this.alert(data.message, offset);
            this.cItem.dislike++;
          }
        })
        .catch((e) => {
          console.log(333, e);
        });
    },
    dislike(e) {
      const div = e.target.parentElement.parentElement;
      const id = this.item.comment_ID;
      const post = commentService.like(id, -1);
      const rect = div.getBoundingClientRect() || {};
      const offset = rect.top || 100;
      if (!post) {
        return;
      }
      post
        .then((res) => {
          const data = res.data;
          if (data.code == -1) {
            this.alert(data.message, offset);
          } else if (data.code == 1) {
            // 成功 num +1
            this.alert(data.message, offset);
            this.cItem.like++;
          }
        })
        .catch((e) => {
          console.log(333, e);
        });
    },
    onCommentReply(e) {
      const div = e.target.parentElement.parentElement;
      const id = div.dataset.id;
      const repl = this.createRelp({
        commentPostID: this.postid,
        commentParent: id,
      });
      div.appendChild(repl.$el);
    },
    createRelp(props) {
      const Constructor = Vue.extend(ReplyForm);
      const comp = new Constructor({
        propsData: props,
      });
      comp.$mount();
      return comp;
    },
    alert(str, offset) {
      this.$message({
        message: str,
        type: "warning",
        offset: offset || 100,
      });
    },
  },
};
